import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  RelationContextType,
  RelationOption,
} from '@components/EntityDrawers/drawers/Relationship/constants/types';
import {
  defaultRelationshipTypes,
  defaultValues,
  RelationshipFormValues,
} from '@components/EntityDrawers/drawers/Relationship/form';
import useStore from '@components/MainStage/store';
import { WeightTypes } from '@constants/entities/relationship';
import { useProject } from '@context/Project';
import { cutNumberPeriods } from '@utils/helpers';

type Options = {
  form: UseFormReturn<RelationshipFormValues>;
  open: boolean;
  editMode: boolean;
  isLastANDAuto: boolean;
  contextType: RelationContextType | null;
  parentOptions: RelationOption[];
};

const useFormReset = ({
  form,
  open,
  editMode,
  isLastANDAuto,
  contextType,
  parentOptions,
}: Options) => {
  const { clearErrors, reset } = form;

  const {
    toolbox: { mode },
  } = useProject();

  const { getActiveEdge } = useStore();
  const activeEdge = getActiveEdge();

  useEffect(() => {
    clearErrors();

    if (open && editMode && activeEdge?.data?.dto) {
      const {
        type,
        dependency,
        description,
        weight,
        weight_type,
        valid_status,
        meta_data,
      } = activeEdge.data.dto;

      setTimeout(
        () =>
          reset({
            type,
            dependency,
            valid_status,
            description: description || '',
            weight: cutNumberPeriods(weight),
            weight_manual: weight_type === WeightTypes.Manual,
            isLastANDAuto,
            context: Object.fromEntries(
              parentOptions.map(({ id }) => {
                const savedValue = meta_data.controls?.[id];

                return [
                  id,
                  savedValue?.length ||
                  contextType === RelationContextType.FunctionTechnology
                    ? savedValue
                    : null,
                ];
              }),
            ),
          }),
        0,
      );

      return;
    }

    reset({
      ...defaultValues,
      type: defaultRelationshipTypes[mode!],
    });
  }, [open, activeEdge?.id, editMode, isLastANDAuto, mode]);
};

export default useFormReset;
